import { toFetchGetStartedStatus } from "@/src/utils/utils.js";

const state = {
  isCompleted: null,
  isLoading: false,
  error: null,
};

const mutations = {
  SET_COMPLETED(state, isCompleted) {
    state.isCompleted = isCompleted;
  },
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};

const actions = {
  async fetchStatus({ commit, state }) {
    if (state.isCompleted !== null) return state.isCompleted;

    commit("SET_LOADING", true);
    commit("SET_ERROR", null);

    try {
      const isCompleted = await toFetchGetStartedStatus();
      commit("SET_COMPLETED", isCompleted);
      return isCompleted;
    } catch (error) {
      console.error("Error fetching get started status:", error);
      commit("SET_ERROR", error);
      return false;
    } finally {
      commit("SET_LOADING", false);
    }
  },
  resetStatus({ commit }) {
    commit("SET_COMPLETED", null);
  },
};

const getters = {
  isGetStartedComplete: (state) => state.isCompleted === true,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
